export const setApiData = (state = [], action) => {
  switch (action.type) {
    case "SET_API_DATA":
      return (state = action.payload);
    case "GET_API_DATA":
      return (action.payload = state);
    default:
      return state;
  }
};

export const setCategoryBrands = (state = [], action) => {
  switch (action.type) {
    case "SET_BRANDS":
      return (state = action.payload);

    default:
      return state;
  }
};

export const addItemToMyCart = (state = [], action) => {
  switch (action.type) {
    case "ADD_ITEM":
      return (state = [...state, action.payload]);
    case "DELETE_ITEM":
      return (state = state.filter((item) => item.id !== action.payload));

    default:
      return state;
  }
};

export const numbersOfItems = (state = 1, action) => {
  switch (action.type) {
    case "INCREASE_ITEM":
      return (state = state + 1);
    case "DECREASE_ITEM":
      return (state = state - 1);

    default:
      return state;
  }
};

export const notificationCart = (state = 0, action) => {
  switch (action.type) {
    case "INCREASE_NOTIFICATION":
      return (state = state + 1);
    case "DECREASE_NOTIFICATION":
      return (state = state - 1);

    default:
      return state;
  }
};
